"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_plaid_link_1 = require("react-plaid-link");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const config_1 = require("config");
const servicing_api_1 = require("servicing-api");
const institution_svg_1 = __importDefault(require("utility-icons/institution.svg"));
const actions_1 = require("../actions");
const reducer_1 = require("../reducer");
function Autopay() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const location = (0, react_router_dom_1.useLocation)();
    const { path } = (0, react_router_dom_1.useRouteMatch)();
    const [linkToken, setLinkToken] = (0, react_1.useState)(null);
    const history = (0, react_router_dom_1.useHistory)();
    const authorizationToken = (0, react_redux_1.useSelector)((state) => reducer_1.selectors.authorizationToken(state));
    const { data: tokenRes } = (0, servicing_api_1.useGetServicingV1InstrumentsTokenTokenQuery)({ token: authorizationToken || '' }, { skip: !authorizationToken });
    const [postBankVerification, { data: bankVerificationRes, isLoading }] = (0, servicing_api_1.usePostServicingV1InstrumentsInstrumentIdBankVerificationMutation)();
    const [exchangePublicToken, { isLoading: isExchangingToken }] = (0, servicing_api_1.usePutServicingV1InstrumentsInstrumentIdBankVerificationExchangePublicTokenMutation)();
    // Extract token from URL params and store in Redux
    (0, react_1.useEffect)(() => {
        const urlParams = new URLSearchParams(location.search);
        const token = urlParams.get('token');
        if (token && !authorizationToken) {
            dispatch((0, actions_1.setAuthorizationToken)(token));
        }
    }, [location.search, authorizationToken, dispatch]);
    // Set instrument ID when tokenRes contains values
    (0, react_1.useEffect)(() => {
        if (tokenRes?.id) {
            dispatch((0, actions_1.setInstrumentId)(tokenRes.id));
        }
    }, [tokenRes, dispatch]);
    // Make API call when authorization token is available and we have the instrument ID
    (0, react_1.useEffect)(() => {
        if (tokenRes?.id && authorizationToken && !bankVerificationRes) {
            postBankVerification({ instrumentId: Number(tokenRes.id) });
        }
    }, [tokenRes, authorizationToken, bankVerificationRes, postBankVerification]);
    // Set link token when API response comes back
    (0, react_1.useEffect)(() => {
        if (bankVerificationRes?.linkToken) {
            setLinkToken(bankVerificationRes.linkToken);
        }
    }, [bankVerificationRes]);
    const { open, ready } = (0, react_plaid_link_1.usePlaidLink)({
        token: linkToken || '',
        onSuccess: (publicToken) => {
            // Exchange public token for access token
            if (tokenRes?.id) {
                exchangePublicToken({
                    instrumentId: Number(tokenRes.id),
                    body: { publicToken },
                }).then((result) => {
                    if ('data' in result) {
                        const { plaidBankAccounts } = result.data;
                        dispatch((0, actions_1.setAccountNumber)(tokenRes.accountId));
                        if (plaidBankAccounts && plaidBankAccounts.length > 1) {
                            // Multiple bank accounts - store them in Redux and redirect to selection
                            dispatch((0, actions_1.setBankAccounts)(plaidBankAccounts));
                            const parentPath = path.replace('/autopay', '');
                            history.push({
                                pathname: (0, config_1.makePath)(parentPath, '/autopay-account-selection'),
                            });
                        }
                        else if (plaidBankAccounts && plaidBankAccounts.length === 1) {
                            // Single bank account - set it as selected and continue to autopay-auth
                            dispatch((0, actions_1.setSelectedBankAccount)(plaidBankAccounts[0]));
                            const parentPath = path.replace('/autopay', '');
                            history.push({
                                pathname: (0, config_1.makePath)(parentPath, '/autopay-auth'),
                            });
                        }
                        else {
                            // No bank accounts - continue to autopay-auth as before
                            const parentPath = path.replace('/autopay', '');
                            history.push({
                                pathname: (0, config_1.makePath)(parentPath, '/autopay-auth'),
                            });
                        }
                    }
                    else if ('error' in result) {
                        // Handle error
                    }
                });
            }
        },
        onExit: () => {
            const parentPath = path.replace('/autopay', '');
            history.push({
                pathname: (0, config_1.makePath)(parentPath, '/autopay-auth'),
            });
        },
    });
    return ((0, jsx_runtime_1.jsxs)("div", { className: "pre-qualification-installment credit-portal pad-20", children: [(0, jsx_runtime_1.jsx)("div", { className: "autopay-icon mar-b-20", children: (0, jsx_runtime_1.jsx)("img", { src: institution_svg_1.default, alt: "agreement" }) }), (0, jsx_runtime_1.jsx)(components_1.H1, { variant: "headline-large", children: "Add AutoPay Account" }), (0, jsx_runtime_1.jsxs)("div", { className: "autopay-container", children: [(0, jsx_runtime_1.jsxs)("ul", { children: [(0, jsx_runtime_1.jsx)(components_1.Li, { variant: "body-large", children: "Your banking information will be used for future payments." }), (0, jsx_runtime_1.jsx)(components_1.Li, { variant: "body-large", children: "You will not be charged until payment is due." })] }), (0, jsx_runtime_1.jsxs)(components_1.P, { variant: "body-large", children: ["By connecting to your bank, you agree to all terms and conditions in this ACH Authorization.", ' '] })] }), (0, jsx_runtime_1.jsx)("div", { className: "flex-center mar-t-20", children: (0, jsx_runtime_1.jsx)(components_1.Button, { type: "submit", className: "button-primary button-warn button-warn-alp-flex w90", onClick: () => open(), disabled: !ready || isLoading || isExchangingToken || !linkToken, children: isLoading
                        ? 'Loading...'
                        : isExchangingToken
                            ? 'Connecting...'
                            : 'Connect Bank Account' }) })] }));
}
exports.default = Autopay;
